/* Icons: */
import ITIcon from '@material-ui/icons/Computer';
import ArticleIcon from '@material-ui/icons/FreeBreakfast';
import ServiceIcon from '@material-ui/icons/Handyman';
import OffsettingIcon from '@material-ui/icons/Payments';
import OfficeIcon from '@material-ui/icons/SupportAgent';

import { useState } from 'react';
import { AdminAppRoute } from 'src/adminPanel/core/AdminAppRoute';
import {
    ROUTE_ADMIN_ARTICLE_MANAGEMENT,
    ROUTE_ADMIN_ARTICLE_MANAGEMENT_ARTICLE,
    ROUTE_ADMIN_ARTICLE_MANAGEMENT_ARTICLE_GROUP,
    ROUTE_ADMIN_ARTICLE_MANAGEMENT_COMMISSION_MODEL,
    ROUTE_ADMIN_ARTICLE_MANAGEMENT_PRODUCT_GROUP,
    ROUTE_ADMIN_IT,
    ROUTE_ADMIN_IT_BARCODE_SCANNER,
    ROUTE_ADMIN_IT_MAILS,
    ROUTE_ADMIN_IT_MARKETING_DOCUMENTS,
    ROUTE_ADMIN_IT_MARKETING_TEXTBLOCKS,
    ROUTE_ADMIN_IT_NO_PAYOUT_RATIONALE,
    ROUTE_ADMIN_IT_ORDER_NOTE_SUBJECTS,
    ROUTE_ADMIN_IT_VIDEOS,
    ROUTE_ADMIN_MOLLIE_BATCH,
    ROUTE_ADMIN_OFFICE,
    ROUTE_ADMIN_OFFICE_ABO_TEMPLATES,
    ROUTE_ADMIN_OFFICE_ADDRESS_CONFIRMATION,
    ROUTE_ADMIN_OFFICE_CALENDAR,
    ROUTE_ADMIN_OFFICE_COFFEE_LEADS_EXPORT,
    ROUTE_ADMIN_OFFICE_CONFIRMATION,
    ROUTE_ADMIN_OFFICE_CUSTOMERS,
    ROUTE_ADMIN_OFFICE_DOWNLOAD_MANAGEMENT,
    ROUTE_ADMIN_OFFICE_LANDING_PAGES_MANAGEMENT,
    ROUTE_ADMIN_OFFICE_MITARBEITERCHIP,
    ROUTE_ADMIN_OFFSETTING,
    ROUTE_ADMIN_OFFSETTING_ADYEN_BATCH,
    ROUTE_ADMIN_OFFSETTING_COMMISSION_INVOICES,
    ROUTE_ADMIN_OFFSETTING_ORDERS,
    ROUTE_ADMIN_OFFSETTING_SEPA,
    ROUTE_ADMIN_PAYPAL_BATCH,
    ROUTE_ADMIN_SEPA_BATCH,
    ROUTE_ADMIN_SERVICE,
    ROUTE_ADMIN_SERVICE_MACHINE_DEPLOYMENT,
    ROUTE_ADMIN_SERVICE_REPAIR_MANAGEMENT_1,
    ROUTE_ADMIN_SERVICE_REPAIR_MANAGEMENT_2,
    ROUTE_ADMIN_SERVICE_REPAIR_MANAGEMENT_3,
    ROUTE_ADMIN_SERVICE_REPAIR_OFFER,
    ROUTE_ADMIN_SERVICE_REPAIR_ORDER,
    ROUTE_ADMIN_SERVICE_SERVICE_COMPLAINTS,
    ROUTE_ADMIN_SERVICE_SERVICE_DRIVE,
} from 'src/config/routes';
import { AppRoute } from 'src/core/AppRoute';
import { useAccount } from 'src/core/hooks/account';
import { useSiteDefinition } from 'src/core/provider/SiteProvider';

interface SideBarGroupI {
    header: AdminAppRoute;
    headerIcon: React.ReactElement;
    value: AdminAppRoute[];
}

export const allMenuItems: SideBarGroupI[] = [
    {
        header: ROUTE_ADMIN_OFFICE,
        headerIcon: <OfficeIcon id={'sideNavIcon'} />,
        value: [
            ROUTE_ADMIN_OFFICE_CUSTOMERS,
            ROUTE_ADMIN_OFFICE_ADDRESS_CONFIRMATION,
            ROUTE_ADMIN_OFFICE_CONFIRMATION,
            ROUTE_ADMIN_OFFICE_DOWNLOAD_MANAGEMENT,
            ROUTE_ADMIN_OFFICE_CALENDAR,
            ROUTE_ADMIN_OFFICE_LANDING_PAGES_MANAGEMENT,
            ROUTE_ADMIN_OFFICE_ABO_TEMPLATES,
            ROUTE_ADMIN_OFFICE_MITARBEITERCHIP,
            ROUTE_ADMIN_OFFICE_COFFEE_LEADS_EXPORT,
        ],
    },
    {
        header: ROUTE_ADMIN_ARTICLE_MANAGEMENT,
        headerIcon: <ArticleIcon id={'sideNavIcon'} />,
        value: [
            ROUTE_ADMIN_ARTICLE_MANAGEMENT_ARTICLE,
            ROUTE_ADMIN_ARTICLE_MANAGEMENT_ARTICLE_GROUP,
            ROUTE_ADMIN_ARTICLE_MANAGEMENT_COMMISSION_MODEL,
            ROUTE_ADMIN_ARTICLE_MANAGEMENT_PRODUCT_GROUP,
        ],
    },
    {
        header: ROUTE_ADMIN_SERVICE,
        headerIcon: <ServiceIcon id={'sideNavIcon'} />,
        value: [
            ROUTE_ADMIN_SERVICE_REPAIR_OFFER,
            ROUTE_ADMIN_SERVICE_REPAIR_ORDER,
            ROUTE_ADMIN_SERVICE_SERVICE_COMPLAINTS,
            ROUTE_ADMIN_SERVICE_SERVICE_DRIVE,
            ROUTE_ADMIN_SERVICE_MACHINE_DEPLOYMENT,
            ROUTE_ADMIN_SERVICE_REPAIR_MANAGEMENT_1,
            ROUTE_ADMIN_SERVICE_REPAIR_MANAGEMENT_2,
            ROUTE_ADMIN_SERVICE_REPAIR_MANAGEMENT_3,
        ],
    },
    {
        header: ROUTE_ADMIN_IT,
        headerIcon: <ITIcon id={'sideNavIcon'} />,
        value: [
            ROUTE_ADMIN_IT_MAILS,
            ROUTE_ADMIN_IT_VIDEOS,
            ROUTE_ADMIN_IT_BARCODE_SCANNER,
            ROUTE_ADMIN_IT_MARKETING_TEXTBLOCKS,
            ROUTE_ADMIN_IT_MARKETING_DOCUMENTS,
            ROUTE_ADMIN_IT_NO_PAYOUT_RATIONALE,
            ROUTE_ADMIN_IT_ORDER_NOTE_SUBJECTS,
        ],
    },
    {
        header: ROUTE_ADMIN_OFFSETTING,
        headerIcon: <OffsettingIcon id={'sideNavIcon'} />,
        value: [
            ROUTE_ADMIN_OFFSETTING_ORDERS,
            ROUTE_ADMIN_OFFSETTING_COMMISSION_INVOICES,
            ROUTE_ADMIN_OFFSETTING_ADYEN_BATCH,
            ROUTE_ADMIN_OFFSETTING_SEPA,
            ROUTE_ADMIN_PAYPAL_BATCH,
            ROUTE_ADMIN_SEPA_BATCH,
            ROUTE_ADMIN_MOLLIE_BATCH,
        ],
    },
];

export const useFilteredAdminAccountRoutes = () => {
    const account = useAccount();
    const site = useSiteDefinition();

    const [menuItems, setMenuItems] = useState<SideBarGroupI[]>(
        allMenuItems.filter(r => {
            if (r.header === ROUTE_ADMIN_SERVICE && site.adminServiceEnabled === false) return false;
            if (!(r.header instanceof AppRoute)) return true;
            if (r.header.accessPrivilege === undefined) return true;
            if (account.hasPrivilege(r.header.accessPrivilege)) return true;
            return false;
        })
    );

    return { menuItems };
};

export const updateInfoBadgeCountOfSideBarHeader = () => {
    allMenuItems.forEach(menu => {
        let sumOfInfoBadegeCountMenu = 0;
        menu.value.map(v => (sumOfInfoBadegeCountMenu += v.infoBadgeCount || 0));
        menu.header.infoBadgeCount = sumOfInfoBadegeCountMenu;
    });
};
